import React, { FC } from 'react';

import { Provider, ErrorBoundary } from '@rollbar/react';
import AppErrorFallback from 'components/AppErrorFallback';
import ChunkErrorBoundary from 'components/ChunkErrorBoundary';
import Layout from 'components/layout/index';
import useFirebaseAuth from 'hooks/useFirebaseAuth';
import AppRoutes from 'routes';

import { rollbarConfigObject } from './rollbarClient';

const App: FC = () => {
  useFirebaseAuth();
  return (
    <Provider config={rollbarConfigObject}>
      <ErrorBoundary fallbackUI={AppErrorFallback}>
        <Layout>
          <ChunkErrorBoundary>
            <AppRoutes />
          </ChunkErrorBoundary>
        </Layout>
      </ErrorBoundary>
    </Provider>
  );
};

export default App;
